import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import MainLayout from '@/components/layout/MainLayout.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/LoginView.vue'),
    meta: {
      title: 'Connexion - Super Admin',
      requiresAuth: false
    }
  },
  {
    path: '/',
    component: MainLayout,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: () => import('../views/DashboardView.vue'),
        meta: {
          title: 'Tableau de Bord - Super Admin'
        }
      },
      {
        path: 'tenants',
        name: 'Tenants',
        component: () => import('../views/TenantsView.vue'),
        meta: {
          title: 'Gestion des Entreprises - Super Admin'
        }
      },
      {
        path: 'tenants/create',
        name: 'CreateTenant',
        component: () => import('../views/CreateTenantView.vue'),
        meta: {
          title: 'Nouvelle Entreprise - Super Admin'
        }
      },
      {
        path: 'tenants/:id',
        name: 'TenantDetail',
        component: () => import('../views/TenantDetailView.vue'),
        meta: {
          title: 'Détails Entreprise - Super Admin'
        }
      },
      {
        path: 'tenants/:id/edit',
        name: 'EditTenant',
        component: () => import('../views/EditTenantView.vue'),
        meta: {
          title: 'Modifier Entreprise - Super Admin'
        }
      },
      // Analytics route - DISABLED
      // {
      //   path: 'analytics',
      //   name: 'Analytics',
      //   component: () => import('../views/AnalyticsView.vue'),
      //   meta: {
      //     title: 'Analytiques - Super Admin'
      //   }
      // },
      {
        path: 'billing',
        name: 'Billing',
        component: () => import('../views/BillingView.vue'),
        meta: {
          title: 'Facturation - Super Admin'
        }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory('/'),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// Navigation guards
router.beforeEach((to, from, next) => {
  // Set page title
  if (to.meta.title) {
    document.title = to.meta.title as string
  }

  // Auth check (simplified for now)
  const isAuthenticated = localStorage.getItem('super_admin_token')
  
  if (to.meta.requiresAuth && !isAuthenticated && to.name !== 'Login') {
    next('/login')
  } else if (to.name === 'Login' && isAuthenticated) {
    next('/')
  } else {
    next()
  }
})

export default router